export default class UserAgentChecker {
  constructor() {
    this.setAppInfo()
    this.options = {
      userAgent: false,
      displayWidth: true,
      displayWidthSP: 768
    }

    this.changeDeviceInfo();
    this.addClass();
    // });
    window.addEventListener('resize', () => {
      this.changeDeviceInfo();
      this.addClass();
    });

  }

  setAppInfo() {
    this.APP = {}
    let ua = navigator.userAgent;
    this.APP.sp = ua.indexOf('iPhone') > -1 || ua.indexOf('iPod') > -1 || ua.indexOf('Android') > -1
  }

  changeDeviceInfo() {
    this.APP.ww = window.innerWidth;
    if(this.options.userAgent && this.options.displayWidth) {
      if (!this.APP.sp && this.options.displayWidthSP < this.APP.ww) {
        this.device = "pc";
      } else {
        this.device = "sp";
      }
    } else if (this.options.userAgent) {
      if (!this.APP.sp) {
        this.device = "pc";
      } else {
        this.device = "sp";
      }
    } else if (this.options.displayWidth) {
      if (this.options.displayWidthSP < this.APP.ww) {
        this.device = "pc";
      } else {
        this.device = "sp";
      }
    }
  }


  addClass() {
    let html = document.getElementsByTagName('html')[0];
    html.setAttribute('class', this.device);
  }

  isPC() {
    return (this.device == "pc");
  }
  isSP() {
    return (this.device == "sp");
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/components/UserAgentChecker.js